/**
 * @generated SignedSource<<8e7ee50e88bf7ef63a32481959040580>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type NovaStudioPageDetailQuery$variables = {
  id: string;
};
export type NovaStudioPageDetailQuery$data = {
  readonly viewer: {
    readonly novaAgent: {
      readonly id: string;
      readonly title: string | null;
      readonly description: string | null;
      readonly systemPrompt: string | null;
      readonly userPromptTemplate: string | null;
      readonly agentMd: string | null;
      readonly categoryId: string | null;
      readonly currentVersionNumber: number | null;
      readonly versions: ReadonlyArray<{
        readonly versionNumber: number;
        readonly createdAt: string | null;
        readonly createdBy: string | null;
        readonly isCurrent: boolean;
      }>;
      readonly files: ReadonlyArray<{
        readonly fileId: string;
        readonly filename: string;
        readonly variableToken: string;
        readonly processingStatus: string;
        readonly sizeBytes: number | null;
        readonly mimeType: string | null;
      }>;
    } | null;
  } | null;
};
export type NovaStudioPageDetailQuery = {
  variables: NovaStudioPageDetailQuery$variables;
  response: NovaStudioPageDetailQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ],
  "concreteType": "NovaAgent",
  "kind": "LinkedField",
  "name": "novaAgent",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "systemPrompt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userPromptTemplate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agentMd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "categoryId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentVersionNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NovaAgentVersion",
      "kind": "LinkedField",
      "name": "versions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "versionNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdBy",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCurrent",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NovaAgentFile",
      "kind": "LinkedField",
      "name": "files",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fileId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "filename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "variableToken",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "processingStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sizeBytes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mimeType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NovaStudioPageDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NovaStudioPageDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1c053fded13e95d2f1331e8066120ffb",
    "id": null,
    "metadata": {},
    "name": "NovaStudioPageDetailQuery",
    "operationKind": "query",
    "text": "query NovaStudioPageDetailQuery(\n  $id: ID!\n) {\n  viewer {\n    novaAgent(id: $id) {\n      id\n      title\n      description\n      systemPrompt\n      userPromptTemplate\n      agentMd\n      categoryId\n      currentVersionNumber\n      versions {\n        versionNumber\n        createdAt\n        createdBy\n        isCurrent\n      }\n      files {\n        fileId\n        filename\n        variableToken\n        processingStatus\n        sizeBytes\n        mimeType\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ac166f680f228f990584b129060e9ab6";

export default node;
